import { useReset } from "components/Filter/Filter.Reset";
import { useState, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { close_drawer } from "state/actions";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import {
  inactiveActions,
  current_language,
  currentActiveProject,
  vis_desktop_nav,
  kioskMode,
  isUnitContactDrawer,
  isOpenContactDrawer,
  active_project,
  vis_compare,
  vis_share,
  vis_calculate_benefit,
  vis_benefit_extended,
  vis_movein_price,
  vis_deposite,
  vis_prepaidrent,
  vis_no_available_unit,
  iso_free,
  iso_isrotating,
  turn_building,
} from "state/store.global";
import { getFocus, setFocus, useFocusGet, useGet } from "state/jotai";
import { _bootstrap } from "state/store.bootstrap";
import { fn3 } from "utilities/utility.misc";
import { initialsort as isr } from "utilities/utility.sort";
import { _project } from "state/store.projects";
import { useRef } from "react";
import { useContactDrawer } from "components/Contact/useContactDrawer";
import { useBookViewingDrawer } from "components/Contact/useBookViewingDrawer";

export const Kiosk = () => {

    const { isOpen: bookIsOpen, toggle: bookViewTgl } = useBookViewingDrawer();
    const { isOpen: cntTglIsOpen, toggle: cntTgl } = useContactDrawer();

  // portals
  const setComp = useAtom(vis_compare)[1];
  const setShare = useAtom(vis_share)[1];
  const setBene = useAtom(vis_calculate_benefit)[1];
  const setBeneExtended = useAtom(vis_benefit_extended)[1];
  const setMP = useAtom(vis_movein_price)[1];
  const setDeposite = useAtom(vis_deposite)[1];
  const setPrePaidRent = useAtom(vis_prepaidrent)[1];
  const setAvailableUnit = useAtom(vis_no_available_unit)[1];

  const type = useFocusGet(_bootstrap, "type");
  const getKioskMode = useGet(kioskMode);
  const closeDrawer = useAtom(close_drawer)[1];

  const [keyboardVisibility, setKeyboardVisibility] = useState(getKioskMode);
  const [layout, setLayout] = useState("default");
  const [input, setInput] = useState("");
  const keyboard = useRef();

  const navigateTo = useNavigate();
  const reset = useReset({ global: false });
  const doInactiveActions = useAtom(inactiveActions)[1];
  const setActiveProject = useAtom(currentActiveProject)[1];
  const [, setShowMenu] = useAtom(vis_desktop_nav);
  const setIsOpen = useAtom(isOpenContactDrawer)[1];
  const sorterOptions = getFocus(_project, "sorteroptions");
  const setDefaultsort = setFocus(_project, "activesorting");
  const { pin, pid } = useGet(active_project);
  const setRmode = useAtom(iso_free)[1];
  const setIsrotate = useAtom(iso_isrotating)[1];
  const setIsTurnBuilding = useAtom(turn_building)[1];
  // const onChange = input => {
  //   setInput(input);
  //   console.log("Input changed", input);
  // };
  // const onKeyPress = button => {
  //   console.log("Button pressed", button);
  //   if (button === "{shift}" || button === "{lock}") handleShift();
  // };

  const onIdle = () => {
    setIsOpen(false);

    reset();
    closeDrawer("detail");
    setShowMenu(false);
    doInactiveActions();
    setActiveProject("");
    navigateTo(`/`);

    // portal closing
    setRmode(false);
    setIsrotate(false);
    setIsTurnBuilding(false);

    setComp(false);
    setShare(false);
    setBene(false);
    setBeneExtended(false);
    setMP(false);
    setDeposite(false);
    setPrePaidRent(false);
    setAvailableUnit(false);

    if (type === "mono")
      setDefaultsort([{ [pid]: isr(sorterOptions?.[pin]?.[pid]) }]);
    else
      setDefaultsort((a) => fn3(a, pin, pid, isr(sorterOptions?.[pin]?.[pid])));

    setKeyboardVisibility(true);
    
    if(bookIsOpen) bookViewTgl()
    if(cntTglIsOpen) cntTgl()
  };
  const {} = useIdleTimer({
    onIdle,
    timeout: 1 * 60000,

    disabled: !getKioskMode, // To disable idle functionality SET to TRUE
  });
  //console.log(keyboardVisibility, "visibility");
  // return (
  //   <div>
  //     {/* ... (existing code) */}

  //     {/* Add the conditional rendering for the KeyboardReact component here */}
  //     {keyboardVisibility && (
  //       <KeyboardReact
  //         keyboardRef={r => (keyboard.current = r)}
  //         layoutName={layout}
  //         onChange={onChange}
  //         onKeyPress={onKeyPress}
  //       />
  //     )}
  //   </div>
  // );
};
